<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()
const getData = async() => {
  await axios.get("./php/getAccessCounter.php")
  .then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h5>アクセスカウンタ</h5>
  <div v-for="day in data.data" :key="day.date">
    <div style="display: inline-flex;align-items: center;">
      <div style="width: 5em;text-align: end;">{{ day.date }}</div>
      <div style="width: 3em;text-align: end;margin: 0 1em;">{{ day.count }}</div>
      <progress :max="data.max" :value="day.count" style="width: 6em;">{{ day.count }}</progress>
    </div>
  </div>
</template>

<style scoped>
</style>